const HTTP_PROTOCOL = /^http:\/\/|^\/\//;
const IMAGE_SIZE = /(\/)(-*\d+x-*\d+)(.\w+)$/;

export const DEFAULT_IMAGE = "http://cdn.gotraffic.net/news/bbimg.jpg";

export default function sizeImage(url: string, width = -1, height = -1) {
    return url
        .replace(HTTP_PROTOCOL, "https://")
        .replace(IMAGE_SIZE, `$1${width}x${height}$3`);
}
